define([

  'underscore'
  ,'lateralus'

], function (

  _
  ,Lateralus

) {
  'use strict';

  var Base = Lateralus.Component.Model;

  var KeyframePropertyModel = Base.extend({
  });

  return KeyframePropertyModel;
});
